export default "__VITE_ASSET__CS_qpu7k__"